<template>
  <div class="dashboard p-4">
    <!-- end nav -->
    <div class="mt-2 w-full">
      <div
        class="lg:flex grid-cols-1 lg:space-y-0 space-y-3 gap-5 justify-between"
      >
        <div>
          <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
            Configure Group
          </h1>
        </div>
      </div>
    </div>
   <div>
    <form class="max-w-sm">
      <div class="mb-5">
        <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Name</label>
        <div class="flex">
          <input v-model="name" type="text" id="email" class="w-5/6 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required />
          <button v-on:click.prevent="editGroup(dataGroupDetail.id, name)" class="w-2/6 ml-2 text-white bg-blue-700 w-10 h-auto hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Submit</button>
        </div>
      </div>
    </form>
   </div>
   <div>
    <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-small">
      Configure Clasification
    </h1>
    <form class="max-w-sm">
      <div class="mb-5">
        <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Add Clasification</label>
        <div class="flex">
          <input v-model="classification" type="text" id="email" class="w-5/6 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required />
          <button v-on:click.prevent="postClass(dataGroupDetail.id, classification)" class="w-2/6 ml-2 text-white bg-blue-700 w-10 h-auto hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Add</button>
        </div>
      </div>
    </form>
    <ul class="w-full text-surface dark:text-white">
      <li v-if="dataGroupDetail?.Classifications?.length == 0" class="w-full text-center border-b-2 border-neutral-100 py-4 dark:border-white/10"> No classification found</li>
      <div class="grid grid-cols-2 gap-x-10">
        <li v-for="(item, index) in dataGroupDetail?.Classifications" :key="index"
          class="w-full border-b-2 border-neutral-300 py-4 dark:border-white/10">
          <div class="flex justify-between">
            {{ item.name }}
            <div class="flex">
              <div v-on:click="editClassHandler(item.id,item.name)" class="hover:scale-110 transition-transform duration-300">
                <svg class="w-6 h-6 mr-3 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"/>
                </svg>

              </div>
              <div v-on:click="delClass(item.id, dataGroupDetail.id)" class="hover:scale-110 transition-transform duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </div>
            </div>
          </div>
        </li>
      </div>
    </ul>
   </div>
    <!-- <div
      class="mt-2 bg-white dark:bg-gray-800 p-5 w-full rounded-md box-border border dark:border-gray-700"
    >
      <h2 class="font-bold text-lg text-gray-800 dark:text-gray-200">
        Track your reward
      </h2>
      <p class="text-gray-400 font-lexend font-normal">
        This is a list of reward
      </p>
      <div class="wrapping-table mt-10">
        <table
          class="w-full text-sm text-left text-gray-500 dark:text-gray-400 lg:overflow-auto overflow-x-scroll"
        >
          <thead
            class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400"
          >
            <tr>
              <th
                scope="col"
                class="uppercase px-1 py-3"
              >
                No
              </th>
              <th
                scope="col"
                class="uppercase px-1 py-3"
              >
                Description
              </th>
              <th
                scope="col"
                class="uppercase px-1 py-3"
              >
                Amount
              </th>
              <th
                scope="col"
                class="uppercase px-6 py-3"
              >
                Date
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 odd:bg-white even:bg-gray-50"
              v-for="(items, i) in dataReward"
              :key="items.id"
            >
              <td class="px-1 py-4">
                {{ i+1 }}
              </td>
              <td class="px-1 py-4">
                {{ items.from }}
              </td>
              <td class="px-1 py-4">
                {{ items.amount }}
              </td>
              <td class="px-6 py-4">
                {{ items.createdAt }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> -->
    <div class="flex mt-5 gap-5">
      <button v-on:click="delButtonGroup" class="inline-flex items-center px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-md">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
        </svg>
        Delete Group
      </button>
      <router-link :to="'/group/'+ dataGroupDetail.id" class="ml-0 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Back</router-link>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import Modal from "@/components/modal.vue";
  import { useCounterStore } from "@/store/counter";
  import { Icon } from "@iconify/vue";
  import { mapActions, mapState } from "pinia";
  export default {
    name: "Dashboard",
    data() {
      return {
        name: '',
        classification: ''
      };
    },
    components: {
      Icon, Modal
    },
    methods: {
      ...mapActions(useCounterStore,['editClass','getDetailGroup','editGroup', 'postClass','delClass','delGroup']),
      async delButtonGroup(){
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        }).then((result) => {
          if (result.isConfirmed) {
           this.delGroup(this.dataGroupDetail.id)
          }
        });
      },
      async editClassHandler(id, name){
        const { value:text } = await Swal.fire({
          input: "text",
          inputLabel: "Name Classification",
          inputPlaceholder: "Enter the name",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          inputValue: name
        });
        if (text) {
          //Swal.fire(`Entered URL: ${text}`);
          this.editClass(id,text, this.dataGroupDetail.id)
        }
      }
    },
    created(){
      this.getDetailGroup(this.$route.params.id)
    },
    computed: {
      ...mapState(useCounterStore, ['dataGroupDetail'])
    },
    mounted() {
      this.name = this.dataGroupDetail.name
    }
  };
</script>
